import react, {useEffect, useState} from "react";

export default function CruiseControl(){
   const[cruiseControlList, setCruiseControlList] =useState([]);

   useEffect(()=>{
      const URLForCruiseControlList =process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/cruisecontrol/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/cruisecontrol/`;
      //const requestOptions={headers: {"Authorization" :  `Token ${'token'}`}});

      const requestOptions = {
         method: 'GET',
         headers: { 'Content-Type': 'application/json' }
      };

     

      fetch(URLForCruiseControlList, requestOptions)
      .then(response => {
         if(response.ok)
            return response.json();
         throw response;
      })
      .then(data => {
         // Add to state variable that will render the List of Crusie Controls available
         setCruiseControlList(()=>[...data]);
      })
      .catch ((error)=>{
         let errMsg="";
         switch (error.status){
            default:
               errMsg="An error has occured. Please try again";
            case '404':
               errMsg="Incorrect URL!"
         }
         alert(errMsg);
      });
   }, []);

   // Now the component to return the setCruiseControlList JSX
   return(
      <ul className="account-card-container">
         {cruiseControlList.map(cruiseControlListObj=>(
            <div className="accountCard">
               <li key={cruiseControlListObj.id}>
                  <div className="cardHeader">{cruiseControlListObj.name}</div>
               </li>
            </div>

         ))}
      </ul>
   );

}